module.exports = __webpack_public_path__ + "static/media/19_(c)_stephan_anders.879a42f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/0420/koeln/19_(c)_stephan_anders.jpg
// module id = 2280
// module chunks = 0